import _toConsumableArray from "C:\\Users\\benja\\Documents\\projects\\dev\\jam-pad-2\\node_modules\\babel-preset-react-app\\node_modules\\@babel\\runtime/helpers/esm/toConsumableArray";

/**
 * Calls all functions in `fs` with args. Only throws after all functions were called.
 *
 * @param {Array<function>} fs
 * @param {Array<any>} args
 */
export var callAll = function callAll(fs, args) {
  var i = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 0;

  try {
    for (; i < fs.length; i++) {
      fs[i].apply(fs, _toConsumableArray(args));
    }
  } finally {
    if (i < fs.length) {
      callAll(fs, args, i + 1);
    }
  }
};
export var nop = function nop() {};
/**
 * @template T
 * @param {function():T} f
 * @return {T}
 */

export var apply = function apply(f) {
  return f();
};